import { createContext } from "react"
const routeContext = createContext({
    sport: "boys_bball",
    setSport: () => {}
  });

export default routeContext